
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
*/

import { RssFeedItem } from '../types';

export const mockRssFeeds: RssFeedItem[] = [
  {
    id: 'rss-12',
    title: 'Constantina Lifestyle Trends',
    titleKey: 'rss_12_title',
    source: 'Constantina',
    sourceKey: 'rss_source_constantina',
    link: 'https://diary.constantinalifestyle.one/feed',
    pubDate: '2026-01-24',
    snippet: 'The season\'s defining pieces.',
    snippetKey: 'rss_12_snippet',
  },
  {
    id: 'rss-1',
    title: 'Vogue Trends 2024',
    titleKey: 'rss_1_title',
    source: 'Vogue',
    sourceKey: 'rss_source_vogue',
    link: 'https://www.vogue.com',
    pubDate: '2025-10-27',
    snippet: 'The season\'s defining pieces.',
    snippetKey: 'rss_1_snippet',
  },
  {
    id: 'rss-2',
    title: 'Street Style Highlights',
    titleKey: 'rss_2_title',
    source: 'Journelles',
    sourceKey: 'rss_source_journelles',
    link: 'https://www.journelles.de',
    pubDate: '2025-10-26',
    snippet: 'Best looks from Milan and Paris.',
    snippetKey: 'rss_2_snippet',
  },
  {
    id: 'rss-3',
    title: 'Future of Footwear',
    titleKey: 'rss_3_title',
    source: 'Highsnobiety',
    sourceKey: 'rss_source_highsnobiety',
    link: 'https://www.highsnobiety.com',
    pubDate: '2025-10-25',
    snippet: 'Latest drops and collaborations.',
    snippetKey: 'rss_3_snippet',
  },
  {
    id: 'rss-4',
    title: 'Sustainable Luxury',
    titleKey: 'rss_4_title',
    source: 'Elle',
    sourceKey: 'rss_source_elle',
    link: 'https://www.elle.com',
    pubDate: '2023-10-25',
    snippet: 'Eco-friendly materials in fashion.',
    snippetKey: 'rss_4_snippet',
  },
  {
    id: 'rss-5',
    title: 'Beauty Decoded',
    titleKey: 'rss_5_title',
    source: 'Harper\'s Bazaar',
    sourceKey: 'rss_source_harpers',
    link: 'https://www.harpersbazaar.com',
    pubDate: '2023-10-24',
    snippet: 'Top beauty trends from the runway.',
    snippetKey: 'rss_5_snippet',
  },
  {
    id: 'rss-6',
    title: 'InStyle Fashion Guide',
    titleKey: 'rss_6_title',
    source: 'InStyle',
    sourceKey: 'rss_source_instyle',
    link: 'https://www.instyle.com',
    pubDate: '2023-10-24',
    snippet: 'Curated shopping picks.',
    snippetKey: 'rss_6_snippet',
  },
  {
    id: 'rss-7',
    title: 'Glamour Runway Report',
    titleKey: 'rss_7_title',
    source: 'Glamour',
    sourceKey: 'rss_source_glamour',
    link: 'https://www.glamour.com',
    pubDate: '2023-10-23',
    snippet: 'Behind the scenes at fashion week.',
    snippetKey: 'rss_7_snippet',
  },
  {
    id: 'rss-8',
    title: 'Beige Editorial',
    titleKey: 'rss_8_title',
    source: 'Beige',
    sourceKey: 'rss_source_beige',
    link: 'https://www.beigebybeige.com',
    pubDate: '2023-10-23',
    snippet: 'Minimalist style and aesthetics.',
    snippetKey: 'rss_8_snippet',
  },
  {
    id: 'rss-9',
    title: 'Refinery29 Style Tips',
    titleKey: 'rss_9_title',
    source: 'Refinery29',
    sourceKey: 'rss_source_refinery29',
    link: 'https://www.refinery29.com',
    pubDate: '2023-10-22',
    snippet: 'Fresh takes on current fashion.',
    snippetKey: 'rss_9_snippet',
  },
  {
    id: 'rss-10',
    title: 'BoF Industry Insights',
    titleKey: 'rss_10_title',
    source: 'Business of Fashion',
    sourceKey: 'rss_source_bof',
    link: 'https://www.businessoffashion.com/news',
    pubDate: '2023-10-22',
    snippet: 'The business side of fashion.',
    snippetKey: 'rss_10_snippet',
  },
  {
    id: 'rss-11',
    title: 'Grazia Trends',
    titleKey: 'rss_11_title',
    source: 'Grazia',
    sourceKey: 'rss_source_grazia',
    link: 'https://www.grazia.com',
    pubDate: '2023-10-21',
    snippet: 'Expert style advice.',
    snippetKey: 'rss_11_snippet',
  },
  {
    id: 'rss-12',
    title: 'Original Copy Mag',
    titleKey: 'rss_12_title',
    source: 'The Original Copy',
    sourceKey: 'rss_source_originalcopy',
    link: 'https://theoriginalcopy.de',
    pubDate: '2023-10-21',
    snippet: 'Digital fashion culture.',
    snippetKey: 'rss_12_snippet',
  },
  {
    id: 'rss-13',
    title: 'Modepilot Updates',
    titleKey: 'rss_13_title',
    source: 'Modepilot',
    sourceKey: 'rss_source_modepilot',
    link: 'https://modepilot.de',
    pubDate: '2023-10-20',
    snippet: 'Daily fashion news.',
    snippetKey: 'rss_13_snippet',
  },
  {
    id: 'rss-14',
    title: 'FashionUnited Global',
    titleKey: 'rss_14_title',
    source: 'FashionUnited',
    sourceKey: 'rss_source_fashionunited',
    link: 'https://fashionunited.com',
    pubDate: '2023-10-20',
    snippet: 'International fashion network.',
    snippetKey: 'rss_14_snippet',
  },
  {
    id: 'rss-15',
    title: 'Jolie Style',
    titleKey: 'rss_15_title',
    source: 'Jolie',
    sourceKey: 'rss_source_jolie',
    link: 'https://www.jolie.de',
    pubDate: '2023-10-19',
    snippet: 'Lifestyle and trends.',
    snippetKey: 'rss_15_snippet',
  },
  {
    id: 'rss-16',
    title: 'Cosmopolitan Fashion',
    titleKey: 'rss_16_title',
    source: 'Cosmopolitan',
    sourceKey: 'rss_source_cosmopolitan',
    link: 'https://www.cosmopolitan.com',
    pubDate: '2023-10-19',
    snippet: 'Empowering style choices.',
    snippetKey: 'rss_16_snippet',
  },
  {
    id: 'rss-17',
    title: 'Masha Sedgwick Blog',
    titleKey: 'rss_17_title',
    source: 'Masha Sedgwick',
    sourceKey: 'rss_source_mashasedgwick',
    link: 'https://www.masha-sedgwick.com',
    pubDate: '2023-10-18',
    snippet: 'Personal style and storytelling.',
    snippetKey: 'rss_17_snippet',
  },
  {
    id: 'rss-18',
    title: 'Ohh Couture Lifestyle',
    titleKey: 'rss_18_title',
    source: 'Ohh Couture',
    sourceKey: 'rss_source_ohhcouture',
    link: 'https://ohhcouture.com',
    pubDate: '2023-10-18',
    snippet: 'Luxury travel and fashion.',
    snippetKey: 'rss_18_snippet',
  },
  {
    id: 'rss-19',
    title: 'Caro Daur Diaries',
    titleKey: 'rss_19_title',
    source: 'Caro Daur',
    sourceKey: 'rss_source_carodaur',
    link: 'https://carodaur.com',
    pubDate: '2023-10-17',
    snippet: 'Behind the scenes with Caro.',
    snippetKey: 'rss_19_snippet',
  },
  {
    id: 'rss-20',
    title: 'Novalanalove Style',
    titleKey: 'rss_20_title',
    source: 'Novalanalove',
    sourceKey: 'rss_source_novalanalove',
    link: 'https://novalanalove.com',
    pubDate: '2023-10-17',
    snippet: 'Daily outfit inspiration.',
    snippetKey: 'rss_20_snippet',
  }
];
